'use client'

import React, { Fragment, useEffect, useState } from 'react'
import { Section } from '@/components/Section'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { GrantFaqsBlock } from '@/payload-types'
import RichText from '@/components/RichText'
import { Separator } from '@/components/Separator'
import { Subheading } from '@/components/ui/subheading'
import { Heading } from '@/components/ui/heading'
import { formatSlug } from '@/fields/slug/formatSlug'

export function GrantFaqsClient({ heading, faqs }: GrantFaqsBlock) {
  const [openItems, setOpenItems] = useState<string[]>(
    // Initialize with all items open
    // faqs?.map((faq) => formatSlug(faq.question)) ?? [],
    // Initialize with first item open
    faqs?.slice(0, 1).map((faq) => formatSlug(faq.question)) ?? [],
  )

  // On page load, open any item that matches the hash
  useEffect(() => {
    if (typeof window !== 'undefined' && window.location.hash && faqs) {
      const hash = window.location.hash.replace('#', '')
      const match = faqs.find((faq) => formatSlug(faq.question) === hash)
      if (match) {
        setOpenItems((prev) => [...prev, formatSlug(match.question)])
      }
    }
  }, [faqs])

  const isQuestionOpen = (question: string) => {
    return openItems.includes(formatSlug(question))
  }

  return (
    <Section className="pb-[100px]" bgClassName="bg-paper-3">
      <div className="flex flex-col max-w-readable-lg gap-y-[60px] mr-auto">
        <Heading size="h2">{heading}</Heading>
        <Accordion type="multiple" value={openItems} onValueChange={setOpenItems}>
          {faqs?.map((faq, index) => (
            <Fragment key={faq.id}>
              <AccordionItem value={formatSlug(faq.question)}>
                <AccordionTrigger>
                  <Subheading
                    anchorLink
                    showAnchor
                    className="text-left"
                    onClick={(e) => {
                      // If the users clicks on the atual link it updates the URL hash
                      // If its already open, leave it open by stopping the event
                      if (isQuestionOpen(faq.question)) {
                        e.stopPropagation()
                      }
                    }}
                  >
                    {faq.question}
                  </Subheading>
                </AccordionTrigger>
                <AccordionContent className="relative pt-[30px]">
                  <RichText className="prose-info prose-dark" data={faq.answer} />
                </AccordionContent>
              </AccordionItem>
              {index !== faqs.length - 1 && <Separator color="rock-1" className="my-[40px]" />}
            </Fragment>
          ))}
        </Accordion>
      </div>
    </Section>
  )
}
